import { TableRow, TableCell, Chip } from "@mui/material"
import { useContext, Dispatch, useState, useEffect, Context, createContext } from "react"
import { apiAuthenticatedContext, api, ActionInfo, ActionGroup, actionIdentifierContext, DataTable } from "./common"
import { User } from './interfaces'
import { INVITE_USER_ACTION, Permission, USERS_ACTIONS } from "./actions";

const UserActionsContext: Context<ActionInfo[]> = createContext([] as ActionInfo[])
function getPermissionStrings(permissions: number){
    let strings = []
    if (permissions & Permission.Admin){
        strings.push("Admin")
    }
    if (permissions & Permission.Start){
        strings.push("Start")
    }
    if (permissions & Permission.Stop){
        strings.push("Stop")
    }
    if (permissions & Permission.Browse){
        strings.push("Browse")
    }
    if (permissions & Permission.Create){
        strings.push("Create")
    }
    if (permissions & Permission.Delete){
        strings.push("Delete")
    }
    if (permissions & Permission.RunCommand){
        strings.push("Run Command")
    }
    if (permissions & Permission.Cloud){
        strings.push("Cloud")
    }
    return strings
}

function UserItem(p: { user: User }) {
    const user = p.user;
    const userActions = useContext(UserActionsContext)

    return (
        <TableRow>
            <TableCell>{user.Username}</TableCell>
            <TableCell>{user.Email}</TableCell>
            <TableCell>{getPermissionStrings(user.Permissions).map((value, index, array) => { return <Chip label={value} /> })}</TableCell>
            <TableCell><ActionGroup actions={userActions} identifierSubstring="username" /></TableCell>
        </TableRow>
    )
}

export function UsersPage(p: {}) {
    const [apiAuthenticated, setApiAuthenticated] = useContext(apiAuthenticatedContext)
    const [users, setUsers]: [User[], Dispatch<User[]>] = useState([] as User[])
    users.sort()

    const action: ActionInfo|undefined = INVITE_USER_ACTION

    useEffect(() => {
        if (!apiAuthenticated) {
            return
        }
        api.get('/users').then((response) => {
            setUsers(response.data) 
        }).catch(
            (error) => {
                console.log('Failed to get users: ' + error);
                if (error.response) {
                    if (error.response.status === 401) {
                        setApiAuthenticated(false)
                    }
                    else if (error.response.status === 403) {
                        setApiAuthenticated(false)
                    }
                }
            }
        )

        const interval = setInterval(() => {
            api.get('/users').then((response) => { 
                setUsers(response.data)

             }).catch(
                (error) => {
                    console.log('Failed to get users: ' + error);
                    if (error.response) {
                        if (error.response.status === 401) {
                            setApiAuthenticated(false)
                        }
                        else if (error.response.status === 403) {
                            setApiAuthenticated(false)
                        }
                    }
                }
            )

        }, 5000
        );
        return () => { clearInterval(interval) }
    }, [apiAuthenticated])

    let userComponents = []

    for (let user of users) {
        userComponents.push(<actionIdentifierContext.Provider value={user.Username}><UserItem user={user} /></actionIdentifierContext.Provider>)
    }

    return <DataTable headers={['Username', 'Email', 'Permissions', 'Actions']} actionInfo={action}>
        <UserActionsContext.Provider value={USERS_ACTIONS}>
            {userComponents}
        </UserActionsContext.Provider>
    </DataTable>
}